import { render, staticRenderFns } from "./AdminCompanyProfile.vue?vue&type=template&id=4bbf4c2c&scoped=true&"
import script from "./AdminCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompanyProfile.vue?vue&type=style&index=0&id=4bbf4c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf4c2c",
  null
  
)

export default component.exports